interface PageTitleProps {
  title: string;
  subtitle?: string | null;
  className?: string;
}

export function PageTitle({ title, subtitle, className = '' }: PageTitleProps) {
  return (
    <div className={`page-title ${className}`}>
      <div className="page-title__content">
        <h2 className="page-title__text">{title}</h2>
        {subtitle && <span className="page-title__badge">{subtitle}</span>}
      </div>
    </div>
  );
}
